import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/review/")({
  beforeLoad: () => {
    throw redirect({ to: "/review/reports" });
  },
});
